import React from 'react'
import { Form } from 'react-bootstrap'

function MunisModule({ params, setParams }) {
  const options = [
    { topmodulecd: 'AP', topmoduledesc: 'Accounts Payable' },
    { topmodulecd: 'AR', topmoduledesc: 'Accounts Receivable' },
    { topmodulecd: 'BG', topmoduledesc: 'Budgeting' },
    { topmodulecd: 'BL', topmoduledesc: 'Business Licenses' },
    { topmodulecd: 'BQ', topmoduledesc: 'Bid Management' },
    { topmodulecd: 'CM', topmoduledesc: 'Contract Management' },
    { topmodulecd: 'EE', topmoduledesc: 'Employee Expense' },
    { topmodulecd: 'FA', topmoduledesc: 'Capital Assets' },
    { topmodulecd: 'GL', topmoduledesc: 'General Ledger' },
    { topmodulecd: 'IF', topmoduledesc: 'Item File' },
    { topmodulecd: 'IN', topmoduledesc: 'Inventory Control' },
    { topmodulecd: 'MS', topmoduledesc: 'Medical Services' },
    { topmodulecd: 'PI', topmoduledesc: 'Permits & Code Enforcement' },
    { topmodulecd: 'PO', topmoduledesc: 'Purchase Orders' },
    { topmodulecd: 'PR', topmoduledesc: 'Payroll' },
    { topmodulecd: 'RM', topmoduledesc: 'Risk Management' },
    { topmodulecd: 'RQ', topmoduledesc: 'Requisitions' },
    { topmodulecd: 'SA', topmoduledesc: 'Student Activity' },
    { topmodulecd: 'SY', topmoduledesc: 'System Administration' },
    { topmodulecd: 'UB', topmoduledesc: 'Utility Billing' },
    { topmodulecd: 'UT', topmoduledesc: 'Utility Billing - CIS' },
    { topmodulecd: 'WA', topmoduledesc: 'Assets' },
    {
      topmodulecd: 'WM',
      topmoduledesc: 'Work Orders Fleet & Facilities Management'
    },
    { topmodulecd: 'WP', topmoduledesc: 'Work Projects' }
  ]

  const handleChange = (event) => {
    setParams({ ...params, selectedModule: event.target.value })
  }

  return (
    <Form.Group controlId="munisModuleSelect">
      <Form.Control
        as="select"
        value={params.selectedModule || ''}
        onChange={handleChange}
      >
        <option value="" disabled>
          Select a module
        </option>
        {options.map((option) => (
          <option key={option.topmodulecd} value={option.topmodulecd}>
            {option.topmoduledesc}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  )
}

export default MunisModule
